/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { imagePath } from '../../utils/ImagePath'
import { CardSection, Heading } from './CardSection'
import {
  FlowContainer,
  FlowHeading,
  LastItemWrapper,
  FlowTitle,
  Time,
  Note,
  Label,
} from './Flow'

export type UsageFlowItem = {
  title: string
  startTime: string
  endTime?: string
  note?: string
}
export type UsageFlowProps = {
  previousDay: UsageFlowItem[]
  thatDay: UsageFlowItem[]
  cautions: string[]
}
export type UsageCaution = {
  content: string
}

export const UsageFlow = ({
  previousDay,
  thatDay,
  cautions,
}: UsageFlowProps) => {
  const containerOverrideStyle = css`
    &::before {
      top: 10px;
    }
  `
  const labelStyle = css`
    margin-top: 2px;
  `
  return (
    <CardSection>
      <Heading as="h3">予約から利用まで</Heading>
      <FlowContainer css={containerOverrideStyle}>
        <FlowTitle style={{ marginTop: 0 }}>利用の前日</FlowTitle>
        {previousDay.map((item, i) => (
          <React.Fragment key={`${i}_${item.title}`}>
            <FlowHeading>
              <Time startTime={item.startTime} endTime={item.endTime} />
            </FlowHeading>
            <Label css={labelStyle}>{item.title}</Label>
            {item.note && <Note>{item.note}</Note>}
          </React.Fragment>
        ))}
        <FlowTitle>利用の当日</FlowTitle>
        {thatDay.map((item, i) =>
          i !== thatDay.length - 1 ? (
            <React.Fragment key={`${i}_${item.title}`}>
              <FlowHeading>
                <Time startTime={item.startTime} endTime={item.endTime} />
              </FlowHeading>
              <Label css={labelStyle}>{item.title}</Label>
              {item.note && <Note>{item.note}</Note>}
            </React.Fragment>
          ) : (
            <LastItemWrapper key={i}>
              <FlowHeading>
                <Time startTime={item.startTime} endTime={item.endTime} />
              </FlowHeading>
              <Label css={labelStyle}>{item.title}</Label>
              {item.note && <Note>{item.note}</Note>}
            </LastItemWrapper>
          ),
        )}
      </FlowContainer>
      {cautions.filter((item) => item.length > 0).length !== 0 && (
        <CautionList>
          {cautions.map((item, i) => (
            <CautionItem key={`${i}_${item}`} content={item} />
          ))}
        </CautionList>
      )}
    </CardSection>
  )
}

const CautionList = styled.ul(css`
  margin: 25px -20px 0px;
  padding: 25px 20px 0px;
  border-top: 1px solid #edeceb;
  display: grid;
  row-gap: 10px;
`)

const CautionItem = ({ content }: { content: string }) => {
  return (
    <li css={CautionItemStyle}>
      <img src={imagePath('usage_caution.svg')} />
      <p>{content}</p>
    </li>
  )
}

const CautionItemStyle = css`
  display: flex;
  align-items: baseline;
  font-size: 12px;
  line-height: 160%;
  color: #3f3d35;
  img {
    margin-right: 5px;
    transform: translateY(3px);
  }
`
